<template>
  <div>
    <activity-component
      :activity="activity"
      :description="description"
    />
  </div>
</template>

<script>
import { getUserData } from '@/auth/utils'
import ActivityComponent from './ActivityComponent.vue'

export default {
  components: {
    ActivityComponent,
  },
  props: {
    activity: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      self: getUserData(),
    }
  },
  computed: {
    description() {
      const {
        user, actionType, oldMentionedUserCount, newMentionedUserCount,
      } = this.activity
      const creator = user?.uuid === this.self.uuid ? this.$t('You') : user.name

      let action = 'added'
      if (oldMentionedUserCount > newMentionedUserCount) {
        action = 'removed'
      } else if (oldMentionedUserCount === newMentionedUserCount) {
        action = 'updated'
      }

      let userNumber = ''
      if (action === 'removed') {
        userNumber = oldMentionedUserCount - newMentionedUserCount
        return `${creator} ${action} ${userNumber} mention${userNumber > 1 ? 's' : ''} from this task.`
      } if (action === 'added') {
        userNumber = newMentionedUserCount - oldMentionedUserCount
        return `${creator} ${action} ${userNumber} mention${userNumber > 1 ? 's' : ''} in this task.`
      }

      return `${creator} ${action} the mentions in this task.`
    },
  },
}
</script>
